import { InjectionToken } from '@angular/core';
import { GatewayConfig } from '@cigna/pdl-viewer/shared/gateway-util';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ContentBundleConfig } from '@cigna/shared/angular/resource-content-data-access';

export const CONFIG = new InjectionToken<Config>('config');

export interface Config {
  production: boolean;
  hmr: boolean;

  oidc: {};

  contentBundle: ContentBundleConfig;

  sessionTimeoutPopup: {
    timeoutDuration: number;
    logoutDuration: number;
    keepAliveUrl: string;
  };

  api: {
    gateways: GatewayConfig;
    proxy: {
      headers: {
        [header: string]: string;
      };
    };
  };
}
